
import api from "../axiosIntercepture";

// Get brand logo and preferences
export const getBrand = async () => {
  try {
    const response = await api.get("brand");
    return response.data?.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch brand and preferences."
    );
  }
};

// Upload brand logo
export const uploadBrandLogo = async (file) => {
  if (!(file instanceof File)) {
    throw new Error("Please select a valid logo image.");
  }

  const formData = new FormData();
  formData.append("brandImage", file, file.name);

  // Verify that FormData contains the actual file.
  console.log("Logo upload details:", {
    name: file.name,
    type: file.type,
    size: file.size,
    formDataFile: formData.get("brandImage"),
  });

  try {
    const response = await api.post("brand/logo", formData, {
      headers: {
        // Override a possible application/json default in the Axios instance.
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Brand logo API error:", {
      status: error?.response?.status,
      response: error?.response?.data,
      message: error?.message,
    });

    throw new Error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to upload brand logo."
    );
  }
};

// Delete brand logo
export const deleteBrandLogo = async () => {
  try {
    const response = await api.delete("brand/logo");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        "Failed to delete brand logo."
    );
  }
};

// Save or update preferences
export const saveBrandPreferences = async (payload) => {
  if (!payload || Object.keys(payload).length === 0) {
    throw new Error("Please provide at least one preference.");
  }

  try {
    const response = await api.post("brand/preferences", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        "Failed to save brand preferences."
    );
  }
};
